import React, { useEffect, useRef, useState } from "react";
import DateRangePicker from "./DateRangePicker/DateRangePicker";
import { Backdrop, Box, ButtonBase, Typography } from "@mui/material";
import "./styles.scss";
import "./theme.scss";
import { colors } from "../../styles/colors";
import { Icon } from "../Icon";

const WIDTH_CALENDAR = 546;
const WIDTH_BUTTON = 300;
const HEIGHT_BUTTON = 39;

const DateRangePickerContainer = ({ ind, value, onChange }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedDefinedRange, setSelectedDefinedRange] = useState(2);
	const containerRef = useRef();
	const calendarRef = useRef();

	const [heightCalendar, setHeightCalendar] = useState(0);

	const handleChangeDateRange = (dateRange) => {
		const { startDate, endDate } = dateRange.selection;
		onChange({ startDate, endDate });
	};

	const [position, setPosition] = useState({ x: 0, y: 0 });

	const updatePosition = () => {
		const rect = containerRef.current.getBoundingClientRect();
		const containerMidpoint = rect.top + rect.height / 2;
		const viewportMidpoint = window.innerHeight / 2;

		const yOffset =
			containerMidpoint > viewportMidpoint
				? rect.top - heightCalendar - 4
				: rect.bottom + 4;

		setPosition({
			x: rect.left - (WIDTH_CALENDAR - WIDTH_BUTTON),
			y: yOffset,
		});
	};

	useEffect(() => {
		window.addEventListener("scroll", updatePosition, true);
		window.addEventListener("resize", updatePosition);

		updatePosition();

		return () => {
			window.removeEventListener("scroll", updatePosition, true);
			window.removeEventListener("resize", updatePosition);
		};
	}, []);

	useEffect(() => {
		// Get the height of the calendar once it is mounted
		if (calendarRef.current) {
			setHeightCalendar(calendarRef.current.clientHeight);
		}
	}, []);

	return (
		<Box
			sx={{ position: "relative" }}
			ref={containerRef}
			data-testid="date-range-picker"
		>
			<Box
				sx={{ borderRadius: "20px" }}
				boxShadow="0 4px 20px 0 rgba(0, 0, 0, 0.05)"
			>
				<ButtonBase
					sx={{
						borderRadius: "20px",
						height: HEIGHT_BUTTON,
						backgroundColor: "white.main",
						width: WIDTH_BUTTON,
						pl: "16px",
						pr: "20px",
						border: "1px solid #EFF0F6",
					}}
					data-testid="date-range-picker-open-button"
					style={{ display: "flex", justifyContent: "space-between" }}
					onClick={() => setIsOpen((prev) => !prev)}
				>
					<Typography>{`Timeframe: ${selectedDefinedRange.label}`}</Typography>
					<Box
						sx={{
							position: "absolute",
							right: "10px",
							display: "flex",
							alignItems: "center",
						}}
					>
						<Icon name={"arrowDownSmall"} />
					</Box>
				</ButtonBase>
			</Box>
			<Backdrop
				sx={{
					color: colors.white,
					zIndex: 10,
					backgroundColor: colors.transparent,
				}}
				open={isOpen}
				onClick={() => setIsOpen(false)}
			>
				<Box
					ref={calendarRef}
					sx={{
						backgroundColor: "white.main",
						borderRadius: 5,
						p: "24px",
						width: WIDTH_CALENDAR,
						position: "absolute",
						top: position.y,
						left: position.x,
					}}
					boxShadow="0 15px 35px 0 rgba(37,51,66, 0.15)"
					onClick={(e) => e.stopPropagation()}
				>
					<DateRangePicker
						selectedDefinedRange={selectedDefinedRange}
						setSelectedDefinedRange={setSelectedDefinedRange}
						showDateDisplay={false}
						ranges={[{ ...value, key: "selection" }]}
						onChange={handleChangeDateRange}
					/>
				</Box>
			</Backdrop>
		</Box>
	);
};

export default DateRangePickerContainer;
